<template>
  <w-icon-wrapper
    :height='24'
    :width='20'
    icon-name='work-edit-mode-off-icon'
    view-box='0 0 20 24'
  >
    <g
      id='_35_Edit-Mode-Off_Icon'
      data-name='35 Edit-Mode-Off_Icon'
      transform='translate(-1.833)'
    >
      <path
        id='Pfad_55708'
        d='M1.833,0V24h20V0Zm18,22h-16V2h16Z'
        data-name='Pfad 55708'
        fill='currentColor'
      />
      <path
        id='Pfad_55709'
        d='M6.833,6h10a1,1,0,0,0,0-2h-10a1,1,0,0,0,0,2Z'
        data-name='Pfad 55709'
        fill='currentColor'
      />
      <path
        id='Pfad_55710'
        d='M6.833,9h7a1,1,0,0,0,0-2h-7a1,1,0,0,0,0,2Z'
        data-name='Pfad 55710'
        fill='currentColor'
      />
      <path
        id='Pfad_55711'
        d='M6.833,12h4a1,1,0,0,0,0-2h-4a1,1,0,0,0,0,2Z'
        data-name='Pfad 55711'
        fill='currentColor'
      />
      <path
        id='Pfad_55712'
        d='M14.626,13.722,10.646,17.7,8.993,16.249a1,1,0,1,0-1.32,1.5l3.061,2.69,5.306-5.305a1,1,0,0,0-1.414-1.414Z'
        data-name='Pfad 55712'
        fill='currentColor'
      />
    </g>
  </w-icon-wrapper>
</template>

<template>
  <w-icon-wrapper
    :height='24.2'
    :width='24.345'
    icon-name='work-edit-mode-on'
    view-box='0 0 24.345 24.2'
  >
    <g
      id='_34_Edit-Mode-On_Icon'
      data-name='34 Edit-Mode-On_Icon'
      transform='translate(-0.424 0.374)'
    >
      <path
        id='Pfad_55704'
        d='M14.89,21.726H2.44v-20H14.89V3.4l1.915-2V-.274H.524v24H16.806V13.216l-1.915,2.01Z'
        data-name='Pfad 55704'
        fill='currentColor'
        stroke='currentColor'
        stroke-width='0.2'
      />
      <path
        id='Pfad_55705'
        d='M12.993,5a.953.953,0,0,0-.9-1H4.9A.953.953,0,0,0,4,5a.953.953,0,0,0,.9,1h7.195A.953.953,0,0,0,12.993,5Z'
        data-name='Pfad 55705'
        fill='currentColor'
        stroke='currentColor'
        stroke-width='0.2'
      />
      <path
        id='Pfad_55706'
        d='M4.951,8a.92.92,0,0,0-.81,1,.92.92,0,0,0,.81,1H8.19A.92.92,0,0,0,9,9a.92.92,0,0,0-.81-1Z'
        data-name='Pfad 55706'
        fill='currentColor'
        stroke='currentColor'
        stroke-width='0.2'
      />
      <path
        id='Pfad_55707'
        d='M23.835.407a2.272,2.272,0,0,0-3.242,0l-1.575,1.6c-.012.011-.019.023-.03.034L7.067,14.141a.779.779,0,0,0-.158.23L4.995,18.545a.81.81,0,0,0,.162.918v0a.785.785,0,0,0,.557.241.766.766,0,0,0,.348-.083l4.049-2.006a.8.8,0,0,0,.211-.154L22.369,5.228c.012-.011.023-.019.034-.03l1.454-1.479.009-.009A2.362,2.362,0,0,0,23.835.407ZM9.3,16.211l-1.9.941.9-1.965L19.678,3.632l1.007,1.016ZM22.732,2.57l-.92.933-1-1.02.923-.933h0a.658.658,0,0,1,.487-.206.725.725,0,0,1,.518.226l.01.01A.708.708,0,0,1,22.732,2.57Z'
        data-name='Pfad 55707'
        fill='currentColor'
        stroke='currentColor'
        stroke-width='0.2'
      />
    </g>
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconEditModeOffAlt' };
</script>